import { Link, useParams } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import { useEffect, useRef } from "react";

export default function Viewsection() {
    const threesections = ['5270e54f-a8d3-4e70-bc48-4bb7962d011f', 'ef2fc67d-969b-4fae-b6cb-6a228d3b633b', 'aed6a565-b25a-493c-8f8e-0adda952e162'];
    const {uuid} = useParams();
    let previous = '';
    let next = '';
    if (threesections.indexOf(uuid) > 0) {
        previous = '/view/' + threesections[threesections.indexOf(uuid) - 1];
    }
    if (threesections.indexOf(uuid) < 2) {
        next = '/view/' + threesections[threesections.indexOf(uuid) + 1];
    } else {
        next = '/course-details';
    }
    const cnt = useRef();
    const title = useRef();
    useEffect(() => {
        console.log('useeffect');
        title.current.innerHTML = '<div class="placeholder-title my-3"></div>';
        cnt.current.innerHTML = '<div class="placeholder-content"></div>';
        window.scroll(-1,0);
        fetch('https://api.voicecoach.net/detis/'+uuid, {Header: {'content-type':'application/json'}})
        .then(res => res.json())
        .then(jr => {
            document.title = jr.title + ' | Voice Coach in Sydney for Podcast | Voicecoach.net';
            title.current.innerHTML = jr.title;
            cnt.current.innerHTML = jr.details;
        });
    }, [uuid]);
    return <><Header />
    <section className="container">
        <div className="row">
            <div className="col-12 col-lg-7 mx-auto">
                <h1 className="mt-5" ref={title}><div className="placeholder-title"></div></h1>
                <div className="content mt-3" ref={cnt}></div>
            </div>
        </div>
        <div className="my-5 row">
            <div className="col-4 text-end">
        { (previous !== '') ? <Link to={previous} className="col-4 btn btn-primary">Previous</Link> : <button className="btn btn-disabled">Previous</button> }
            </div>
            <div className="col-4 text-center">
        <Link to="/booking" className="btn big-button btn-primary mb-5">Start Learning</Link>
            </div>
            <div className="col-4 text-start">
        <Link to={next} className="col-4 btn btn-primary">Next</Link>
            </div>
        </div>
    </section>
    <Footer /></>
}
